import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import OrderFormPriceContainer from '../OrderFormPriceContainer'

import DefaultSummaryContainer from '@/checkout-instore-legacy/components/Commons/Summary/containers/DefaultSummaryContainer'
import {
  withMediaQuery,
  isDesktopBreakpoint,
} from '@/checkout-instore-legacy/utils/mediaQuery'
import Footer from '../Footer'

class SummaryView extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showFullSummary: false,
    }
  }

  handleToggleSummary = () => {
    this.setState({ showFullSummary: !this.state.showFullSummary })
  }

  componentDidUpdate() {
    const { breakpoint } = this.props
    const { showFullSummary } = this.state
    if (showFullSummary && isDesktopBreakpoint(breakpoint)) {
      this.setState({ showFullSummary: false })
    }
  }

  render() {
    const { showFullSummary } = this.state
    const {
      id,
      children,
      containerType,
      onSubmit,
      summaryContent,
      titleRightElement,
      hasAtLeastOneValidItem,
      disableAutocomplete,
    } = this.props
    const className = this.props.className ? ` ${this.props.className}` : ''

    const containerProps = {
      id,
      onSubmit,
      className: `flex bg-base flex-row-l flex-column flex-auto w-100 h-100 ${className} ${
        showFullSummary ? 'z-999 top-0 fixed static-l' : ''
      }`,
    }

    if (disableAutocomplete) {
      containerProps.autoComplete = 'off'
    }

    const content = (
      <div
        key="content"
        className="flex flex-column w-100 flex-auto flex-row-l"
      >
        <div
          className={`flex flex-column animate-height ${
            showFullSummary ? 'overflow-hidden h-0' : 'flex-auto'
          }`}
        >
          {children}
        </div>
        <div
          className={`flex flex-column w-25-l flex-grow-0-l no-print bn bl-l b--black-20 ${
            showFullSummary ? 'flex-auto' : 'flex-shrink-0 flex-grow-0'
          }`}
        >
          <Footer
            showFullSummary={showFullSummary}
            onHandleToggleSummary={this.handleToggleSummary}
            rightElement={
              titleRightElement || (
                <OrderFormPriceContainer
                  hasAtLeastOneValidItem={hasAtLeastOneValidItem}
                />
              )
            }
          >
            {summaryContent || (
              <DefaultSummaryContainer
                onHandleToggleSummary={this.handleToggleSummary}
                hasAtLeastOneValidItem={hasAtLeastOneValidItem}
              />
            )}
          </Footer>
          {this.props.renderFooterButton && (
            <React.Fragment key="footer">
              {showFullSummary || <hr className="o-30 mh5 mv0" size="1" />}
              <div className="flex-none">
                {this.props.renderFooterButton(showFullSummary)}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    )

    switch (containerType) {
      case 'form':
        return <form {...containerProps}>{content}</form>
      default:
        return <div {...containerProps}>{content}</div>
    }
  }
}

SummaryView.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string,
  onSubmit: PropTypes.func,
  containerType: PropTypes.oneOf(['div', 'form']),
  className: PropTypes.string,
  renderFooterButton: PropTypes.func,
  summaryContent: PropTypes.node,
  titleRightElement: PropTypes.node,
  breakpoint: PropTypes.string,
  hasAtLeastOneValidItem: PropTypes.bool,
  disableAutocomplete: PropTypes.bool,
}

export default withMediaQuery(SummaryView)
